import React, { Component } from "react";
import PropTypes from "prop-types";

import TourModal from "./TourModal";

import urlServices from "services/urlServices";

const propTypes = {
  projectId: PropTypes.number,
  showModal: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  language: PropTypes.string
};

class TourModalContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      completedTour: false,
      slidesLength: null
    };

    this.setCompletedTour = this.setCompletedTour.bind(this);
    this.setSlidesLength = this.setSlidesLength.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      (typeof this.state.slidesLength !== "number" &&
        this.state.slidesLength !== nextState.slidesLength &&
        nextState.slidesLength > 0) ||
      this.state.completedTour !== nextState.completedTour
    );
  }

  getCurrentUrlPath() {
    return urlServices.defaultPath();
  }

  setCompletedTour() {
    this.setState({ completedTour: true });
  }

  setSlidesLength(slidesLength) {
    this.setState({ slidesLength: slidesLength });
  }

  handleCloseClick = e => {
    e.preventDefault();

    this.props.handleCloseModal();
  };

  render() {
    return (
      <TourModal
        projectId={this.props.projectId}
        showModal={this.props.showModal}
        redirectUrl={this.getCurrentUrlPath()}
        completedTour={this.state.completedTour}
        slidesLength={this.state.slidesLength}
        setCompletedTour={this.setCompletedTour}
        setSlidesLength={this.setSlidesLength}
        handleCloseModal={this.props.handleCloseModal}
        handleCloseClick={this.handleCloseClick}
        language={this.props.language}
      />
    );
  }
}

TourModalContainer.propTypes = propTypes;

export default TourModalContainer;
